import React from 'react';
import { LinearProgress } from 'material-ui/Progress';
import { withStyles } from 'material-ui';
import { getUsers } from './userServices';
import UsersTable from './UsersTable';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { translate } from 'react-i18next';
import UserDeleteDialog from './UserDeleteDialog';
import UserAddDialog from './UserAddDialog';

const styles = theme => ({
    column: {
        flexBasis: '33.33%'
    },
    columnall: {
        flexBasis: '77.77%',
        marginRight: '64px'
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3155A1'
    },
    button: {
        height: '42px',
        width: '190px',
        marginTop: '24px'
    },
    filterTitle: {
        color: theme.palette.primary.contrastText,
        fontSize: '16px'
    },
    expansionPanelFilter: {
        backgroundColor: theme.palette.primary.main
    },
    expansionIcon: {
        color: theme.palette.primary.contrastText
    }
});
/**
 * Componente que lista mis reservas
 */
class UsersView extends OLYWebPageComponent {

    constructor(props) {
        super(props);

        this.pageName = 'Users';
        this.pageReference =
            'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/621740036/UI+-+Mis+Reservas';

        this.state = {
            data: [],
            loading: false,
            userToDelete: {},
            openAdd: false,
            openDelete: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchBackendData();
    }

    tableActionsMenuHandler = (user, action) => {

        switch (action) {
        case 'ADD':
            this.setState({ userToEdit: null });
            this.openAddUser();
            break;
        case 'DELETE':
            //el UserDeleteDialog requiere esta prop.
            user.user_name = user.userName;
            this.setState({ userToDelete: user });
            this.openDeleteUser();
            break;
        case 'EDIT':
            user.user_name = user.userName;
            this.setState({ userToEdit: user });
            this.openAddUser();
            break;

        default:
            //alert();
            break;
        }
    };

    handleSubmit = () => {
        this.fetchBackendData();
    };

    fetchBackendData = () => {
        this.setState({ loading: true });
        getUsers()
            .then(users => {
                this.setState({ data: users });
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    openAddUser = () => {
        this.setState({ openAdd: true });
    };

    closeAdd = success => {
        if (success) {
            this.fetchBackendData();
        }
        this.setState({ openAdd: false });
    };

    openDeleteUser = () => {
        this.setState({ openDelete: true });
    };

    closeDelete = success => {
        if (success) {
            this.fetchBackendData();
        }
        this.setState({ openDelete: false, userToDelete: {} });
    };



    render() {
        const { t } = this.props;
        return (
            <div>
                <div>
                    {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                </div>
                <UsersTable
                    data={this.state.data}
                    actionhandler={this.tableActionsMenuHandler}
                    allowedActions={['EDIT', 'DELETE']}
                    menuactionslabels={{
                        EDIT: t('USER.EDIT'),
                        DELETE: t('USER.DELETE')
                    }}
                />

                <UserAddDialog
                    open={this.state.openAdd}
                    onClose={this.closeAdd}
                    user={this.state.userToEdit}
                />

                <UserDeleteDialog
                    open={this.state.openDelete}
                    onClose={this.closeDelete}
                    user={this.state.userToDelete}
                />
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(UsersView));



// WEBPACK FOOTER //
// ./src/components/User/UsersView.js